import { fetchInventoryStockByScanCode } from '#/api/imsMgmt/inventoryStock/fetchByScanCode';

function isNotFoundError(error) {
  return error?.response?.status === 404
    || error?.response?.data?.code === 'INVENTORY_STOCK_NOT_FOUND';
}

export const STOCK_NO_SCAN_LABELS = {
  trigger: '掃庫存編號',
  title: '掃庫存編號加入轉倉明細',
  description: '掃描或輸入庫存編號，累加至下方清單後確認加入。來源倉不得與轉倉倉別相同。',
  inputLabel: '輸入庫存編號',
  inputTip: '可用掃碼機輸入。命中一筆會加入下方清單；若同一庫編對應多筆庫存會再開視窗選一個。',
  confirm: '確認加入',
  scannedListTitle: '已掃描庫存',
  emptyList: '尚未掃描庫存，請輸入或掃入庫存編號。',
  notFound: '未找到對應庫存編號',
  duplicate: '此庫存已在掃描清單中，未重複加入',
  ambiguousTitle: '選擇庫存',
  ambiguousDescription: (code) => (
    code
      ? `庫存編號「${code}」對應多筆庫存，請單選一筆加入。`
      : '此庫存編號對應多筆庫存，請單選一筆加入。'
  ),
  ambiguousConfirm: '加入',
};

export function getStockNoItemId(item) {
  const raw = item?.id ?? item?.stockId ?? item?.invStockId;
  if (raw == null || raw === '') {
    return '';
  }
  return String(raw);
}

/**
 * 掃庫存編號。404／NOT_FOUND 轉成 items: []，其餘錯誤上拋。
 */
export async function lookupStockNo(code, { mode = 'stockNo' } = {}) {
  try {
    const response = await fetchInventoryStockByScanCode({
      mode,
      code,
    });
    return {
      items: Array.isArray(response?.data) ? response.data : [],
    };
  } catch (error) {
    if (isNotFoundError(error)) {
      return { items: [] };
    }
    throw error;
  }
}
